import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styles from './Login.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from "react-redux";
import {
    checkMSToken
} from './loginSlice'
import { useNavigate } from "react-router-dom";
import { validateEmail } from "../../app/utils/helpers"
import Langs from "../../app/lang/langs";
import logo from "../../assets/images/Logo-Groupe-Vital-Blanc-Baseline.png";
import { SignInButton } from '../../components/buttons/SignInButton';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../app/utils/authConfig";
import { ThemeButton } from '../../components/buttons/ThemeButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

function getDeviceType() {
    const w = window.innerWidth;
    if (w <= 768) return 2;   // mobile
    if (w <= 1200) return 3;  // tablet
    return 1;                 // desktop
}

export function LoginPage(props) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isAuthenticated = useIsAuthenticated()
    const isLoading = useSelector((state) => state.common.isLoading)
    const loginError = useSelector((state) => state.login.loginError)
    const formView = useSelector((state) => state.login.formView)
    const isMobileRedux = useSelector((state) => state.settings.isMobile)
    const [localDevice, setLocalDevice] = useState(getDeviceType)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [formError, setFormError] = useState('')
    const [collabsInput, setCollabsInput] = useState(false)
    const { instance, accounts, inProgress } = useMsal()

    const isMobile = isMobileRedux || localDevice

    useEffect(() => {
        const onResize = () => setLocalDevice(getDeviceType());
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [])


    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            instance.acquireTokenSilent(request).then((response) => {
                dispatch(checkMSToken(response))
            }).catch((e) => {
                instance.acquireTokenPopup(request).then((response) => {
                    dispatch(checkMSToken(response))
                })
            })
        }
    }, [isAuthenticated])



    function getLoginformView() {
        return <Row>
            <Row className="m-auto">
                <Col md={10} className="m-auto p-2 text-center">
                    <SignInButton />
                </Col>
            </Row>
            <Row className="m-auto">
                <Col md={10} className="m-auto p-2 text-center">
                </Col>
            </Row>
        </Row>
    }

    // Mobile / Tablet layout (isMobile === 2 or 3)
    if (isMobile === 2 || isMobile === 3) {
        return (
            <Box
                className={`${styles.background} ${styles.mobileBackground}`}
                sx={{
                    minHeight: '100vh',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: isMobile === 2 ? 2.5 : 5,
                    py: 4,
                    boxSizing: 'border-box',
                }}
            >
                {/* Floating particles layer */}
                <Box className={styles.mobileParticles}>
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle1}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle2}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle3}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle4}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle5}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle6}`} />
                </Box>

                <Fade in timeout={600}>
                    <Box
                        className={styles.mobileContent}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                            maxWidth: isMobile === 2 ? 360 : 440,
                        }}
                    >
                        {/* Logo with floating animation */}
                        <Box
                            component="img"
                            src={logo}
                            alt="logo"
                            className={styles.mobileLogo}
                            sx={{
                                width: isMobile === 2 ? '70%' : '55%',
                                maxWidth: 280,
                                mb: 5,
                            }}
                        />

                        {/* Orb glow behind card */}
                        <Box sx={{ position: 'relative', width: '100%' }}>
                            <Box className={styles.mobileOrb} />

                            {/* Glassmorphic card */}
                            <Box className={styles.mobileCard}
                                sx={{
                                    width: '100%',
                                    px: isMobile === 2 ? 2.5 : 4,
                                    py: isMobile === 2 ? 4 : 5,
                                    position: 'relative',
                                }}
                            >
                                {/* Card inner with corner accents */}
                                <Box className={styles.mobileCardInner}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2.5,
                                    }}
                                >
                                    {/* Welcome text with shimmer */}
                                    <Typography
                                        className={styles.mobileWelcomeText}
                                        sx={{
                                            fontFamily: "'Inter', 'Roboto', sans-serif",
                                            fontSize: isMobile === 2 ? '24px' : '28px',
                                            lineHeight: 1.3,
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Langs str='WELCOME_TEXT' />
                                    </Typography>

                                    {/* Decorative divider */}
                                    <Box className={styles.mobileDivider} />

                                    {/* Sign in button */}
                                    <Box
                                        className={styles.mobileButtonWrap}
                                        sx={{
                                            width: '100%',
                                            mt: 1,
                                            '& button': {
                                                fontSize: '16px',
                                                minHeight: '52px',
                                                width: '100%',
                                                borderRadius: '14px !important',
                                            },
                                        }}
                                    >
                                        <SignInButton />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        {/* Brand mark */}
                        <Box className={styles.mobileBrandMark}>
                            Groupe Vital
                        </Box>
                    </Box>
                </Fade>
            </Box>
        );
    }

    // Desktop layout (isMobile === 1) - unchanged
    return <div>
        <Container fluid className={styles.fullHeight + " " + styles.background}>
            <Row className="d-flex justify-content-center align-items-top min-vh-100 text-center">
                <Col lg={4} className="p-4 text-left">
                    <img className={styles.logo} src={logo} alt={"logo"} />
                </Col>
                <Col lg={4} className={styles.loginContainer + " align-self-center"}>
                    <Row>
                        <Col md={12} className="m-auto p-4 text-center">
                            <span className={styles.welcomeText}>
                                <Langs str='WELCOME_TEXT' />
                            </span>
                        </Col>
                    </Row>
                    {getLoginformView()}
                </Col>
                <Col lg={4}>

                </Col>
            </Row>
        </Container>
    </div>
}
